import { ChainId } from '@mimoprotocol/swap-sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xACCE294bf7D25Fe8C5C64Ae45197d3878F68403b', // TODO
  [ChainId.IOTEXTESTNET]: '0xe980c6BC4ff99e3E8431b680a58344B8e0170bE0',
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
